<template>
  <div v-if="open" class="overlay" @click.self="handleBackdropClose">
    <div class="modal">
      <div class="eyebrow">Mover hoja</div>
      <h3>{{ resolvedTitle }}</h3>
      <p class="description">{{ resolvedDescription }}</p>

      <div v-if="state === 'success'" class="success-box">
        <div class="success-icon-wrap">
          <span class="success-icon">✓</span>
        </div>
        <div>
          <strong>Movimiento completado</strong>
          <p>Esta ventana se cerrará automáticamente en {{ countdown }} segundo<span v-if="countdown !== 1">s</span>.</p>
        </div>
      </div>

      <div class="progress-wrap" v-if="state === 'success'">
        <div class="progress-bar" :style="{ width: progressWidth }"></div>
      </div>

      <div class="actions">
        <button type="button" class="ghost-btn" @click="$emit('close')" :disabled="state === 'loading'">
          {{ state === 'success' ? 'Cerrar ahora' : 'Cancelar' }}
        </button>
        <button
          v-if="state !== 'success'"
          type="button"
          class="dark-btn"
          :class="{ loading: state === 'loading' }"
          :disabled="state === 'loading'"
          @click="$emit('confirm')"
        >
          <span v-if="state === 'loading'" class="spinner"></span>
          <span>{{ state === 'loading' ? 'Moviendo…' : 'Confirmar movimiento' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoveListModal',
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: 'Confirmar acción' },
    description: { type: String, default: '' },
    state: { type: String, default: 'idle' },
    countdown: { type: Number, default: 3 },
  },
  emits: ['close', 'confirm'],
  computed: {
    resolvedTitle() {
      return this.state === 'success' ? 'Hoja movida correctamente' : this.title;
    },
    resolvedDescription() {
      if (this.state === 'success') {
        return 'El cambio ya se aplicó correctamente y la lista se actualizó.';
      }
      return this.description;
    },
    progressWidth() {
      const seconds = Math.max(0, Math.min(3, Number(this.countdown || 0)));
      return `${(seconds / 3) * 100}%`;
    },
  },
  methods: {
    handleBackdropClose() {
      if (this.state === 'loading') return;
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.overlay { position: fixed; inset: 0; background: rgba(15, 23, 42, 0.34); display: grid; place-items: center; padding: 24px; z-index: 65; }
.modal { width: min(560px, 100%); background: rgba(255,255,255,.98); border: 1px solid rgba(148,163,184,.24); border-radius: 24px; padding: 22px; box-shadow: 0 24px 70px rgba(15,23,42,.18); }
.eyebrow { font-size: 12px; text-transform: uppercase; letter-spacing: .12em; color: #64748b; }
h3 { margin: 8px 0 0; font-size: 28px; color: #0f172a; }
.description { margin: 12px 0 0; color: #475569; line-height: 1.55; }
.success-box { display: flex; gap: 14px; align-items: center; margin-top: 16px; padding: 14px; border-radius: 18px; background: rgba(236, 253, 245, 0.92); border: 1px solid rgba(16, 185, 129, 0.16); }
.success-icon-wrap { width: 48px; height: 48px; min-width: 48px; display: grid; place-items: center; border-radius: 999px; background: #16a34a; }
.success-icon { color: white; font-size: 24px; font-weight: 900; }
.success-box strong { display: block; color: #065f46; }
.success-box p { margin: 4px 0 0; color: #047857; }
.progress-wrap { height: 8px; margin-top: 14px; border-radius: 999px; overflow: hidden; background: rgba(148, 163, 184, 0.18); }
.progress-bar { height: 100%; border-radius: 999px; background: linear-gradient(90deg, #16a34a, #22c55e); transition: width .9s linear; }
.actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 18px; }
.ghost-btn, .dark-btn { border: none; border-radius: 14px; padding: 12px 14px; font-weight: 800; cursor: pointer; }
.ghost-btn { background: rgba(241,245,249,.92); color: #334155; }
.dark-btn { background: #111827; color: white; min-width: 192px; display: inline-flex; align-items: center; justify-content: center; gap: 10px; }
.dark-btn:disabled, .ghost-btn:disabled { opacity: .7; cursor: not-allowed; }
.spinner { width: 18px; height: 18px; border-radius: 999px; border: 2px solid rgba(255,255,255,.35); border-top-color: white; animation: spin .8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
</style>
